export default {
  "content": "<path fill=\"#c9cbd4\" d=\"M5.5 22.12V17.8H4v-1.44h3v5.76zm3.5 0v-2.4q0-.408.287-.684A1 1 0 0110 18.76h2v-.96H9v-1.44h3.5q.424 0 .713.276a.9.9 0 01.287.684v1.44a.9.9 0 01-.287.684 1 1 0 01-.713.276h-2v.96h3v1.44zm6 0v-1.44h3v-.96h-2v-.96h2v-.96h-3v-1.44h3.5q.424 0 .712.276a.9.9 0 01.288.684v3.84a.9.9 0 01-.288.684 1 1 0 01-.712.276zM4 5.32L8.444 1l4.445 4.32-1.245 1.231-2.31-2.246v9.655h-1.78V4.305L5.245 6.55z\"/><path fill=\"#c9cbd4\" d=\"M19.889 9.64l-4.445 4.32L11 9.64l1.244-1.231 2.312 2.246V1h1.777v9.655l2.311-2.246z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none"
  }
};